import { Config } from "~/constants/configuration_provider";

export const MSI_POWERSHELL_COMMAND = `Start-Process -Wait msiexec -ArgumentList '/qn /i mondoo.msi'`;

export const MSI_CMD_COMMAND = `start /wait msiexec /qn /i mondoo.msi`;

export const SCAN_COMMAND = `cnspec scan local`;

export function buildPowerShellInstallCommand(tokenValue: string): string {
  return `[Net.ServicePointManager]::SecurityProtocol = [Net.SecurityProtocolType]::Tls12
iex ((New-Object System.Net.WebClient).DownloadString('https://${Config.VITE_INSTALL_HOST}/ps1'));
Install-Mondoo -RegistrationToken '${tokenValue}' -Service enable -UpdateTask enable -Time 12:00 -Interval 3;`;
}

export function buildConfigureServiceCommand(tokenValue: string): string {
  return `# Login to Mondoo platform
cnspec login -t '${tokenValue}'

# Set cnspec to run as a service automatically at startup
Set-Service -Name mondoo -StartupType Automatic

# Start the Mondoo service
Set-Service -Name mondoo -Status Running -StartupType Automatic

# Validate service is running
Get-Service mondoo | Select-Object -Property Name, StartType, Status`;
}
